import { useEffect, useState } from 'react';
import api from './api';
import { DEFAULT_PACKAGES, DEFAULT_SETTINGS } from './siteDefaults';

// Text and options the admin panel can change. Defaults show immediately;
// the live values replace them when the API answers.
export function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    let cancelled = false;
    api
      .get('/api/site-settings')
      .then((response) => {
        if (!cancelled && response.data && response.data.contact) {
          setSettings({ ...DEFAULT_SETTINGS, ...response.data });
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return settings;
}

// Credit packages for the pricing popup and the pricing list.
export function usePackages() {
  const [packages, setPackages] = useState(DEFAULT_PACKAGES);
  useEffect(() => {
    let cancelled = false;
    api
      .get('/api/packages')
      .then((response) => {
        if (!cancelled && response.data && Array.isArray(response.data.packages)) {
          setPackages(response.data.packages);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return packages;
}
